import { Flex, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './appLoader.module.less';

type AppLoaderProps = {
    isFullScreen?: boolean;
};

/**
 * A loading indicator that will be shown when the app is loading
 * @returns
 */
export function AppLoader({ isFullScreen = true }: AppLoaderProps) {
    return (
        <Flex
            justify="center"
            align="center"
            className={[styles.appLoader, isFullScreen ? styles.fullScreen : ''].join(' ')}
        >
            <Spin
                size="large"
                className={styles.loaderIndicator}
                indicator={<LoadingOutlined className={styles.loaderIcon} />}
            />
        </Flex>
    );
}
